import { checkStatus } from '../../utilities/fetch';
import { analyticsActivitiesPath } from '../../utilities/api_relative_paths';

/**
 * Performs a POST request to track an activity
 *
 * @param {object} data - Data object with its properties
 * @param {string} data.activity - Action to track (share, view...)
 * @param {string} data.target_id - Object id to track
 * @param {string} data.target_type - Target type to track (Article, Job...)
 * @param {string} [data.detail] - More info for the tracking (facebook, twitter...)
 *
 * @returns {Promise} Promise that can be consumed
 */
const trackActivity = (data) => {
  if (!data || !data.activity || !data.target_id || !data.target_type)
    return Promise.reject('Missing params');

  const requestOptions = {
    method: 'POST',
    body: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
    },
  };

  return fetch(analyticsActivitiesPath, requestOptions)
    .then(checkStatus)
    .then((response) => response.json())
    .catch((error) => Promise.reject(error));
};

export { trackActivity };
